import Styles from "../styles/Footer.module.css";
import Logo from "../images/nadali_logo.jpg";


export default function Footer(){

	return(
		<footer>
			<div className={Styles.footerLogo}>
				<img src={Logo} alt="Logo" />
			</div>
			<div className={Styles.footerText}>
				© {new Date().getFullYear()} NADALI coffee shop, designed & built by{" "}
        <a href="https://cytechsharp.com.cy" target="_blank" rel="noreferrer" style={{color: "white"}}>
          CyTechSharp
        </a>
			</div>
		</footer>
	)
}